var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 31,
    viewBox: "0 0 56 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2676 6.36365C32.314 6.36365 28.7808 8.38754 28.7808 12.1268C28.7808 16.4151 35.047 16.7112 35.047 18.8655C35.047 19.7726 33.9944 20.5846 32.1967 20.5846C29.6455 20.5846 27.7386 19.45 27.7386 19.45L26.9227 23.2234C26.9227 23.2234 29.1194 24.1818 32.0358 24.1818C36.3583 24.1818 39.7597 22.0585 39.7597 18.2553C39.7597 13.724 33.4674 13.4366 33.4674 11.4371C33.4674 10.7264 34.3314 9.94788 36.124 9.94788C38.1465 9.94788 39.7967 10.773 39.7967 10.773L40.5952 7.12865C40.5952 7.12865 38.7997 6.36365 36.2676 6.36365ZM0.0957571 6.63872L0 7.18882C0 7.18882 1.66332 7.48943 3.16138 8.08918C5.09023 8.77684 5.22768 9.17721 5.55252 10.4206L9.09241 23.8981H13.8378L21.1483 6.63872H16.4139L11.7164 18.3735L9.79961 8.42652C9.62381 7.28812 8.73335 6.63872 7.6434 6.63872H0.0957571ZM23.0521 6.63872L19.3381 23.8981H23.8528L27.5537 6.63867H23.0521V6.63872ZM48.2321 6.63872C47.1434 6.63872 46.5666 7.21436 46.1433 8.22025L39.529 23.8981H44.2635L45.1795 21.2851H50.9474L51.5044 23.8981H55.6818L52.0374 6.63872H48.2321ZM48.8478 11.3017L50.2511 17.7782H46.4914L48.8478 11.3017Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bba50d8fdf75876aa3a8858c30909f88.svg";
export { ForwardRef as ReactComponent };